import { useContext } from "react";
import { useIntl } from "react-intl";

import { useMutation } from "@tanstack/react-query";

import { Cafs } from "../../../api/export";
import { AppContext, SnackbarType } from "../../../AppContext";
import { MutationKey } from "../../../consts/mutation-keys";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { useFetchError } from "../../../hooks/useFetchError";
import { FileResponse } from "../../../http-client";
import { ApiError } from "../../../types/api-error";
import { saveFile } from "../../../utils/save-file";
import { DashboardContext } from "../DashboardContext";

export const useExportAllCalibrations = () => {
  const { selectedDataset } = useContext(DashboardContext);
  const { showSnackbar } = useContext(AppContext);

  const { formatMessage } = useIntl();

  const { handleSuccess } = useApiSuccess({
    snackbarText: formatMessage({
      id: "ACTION.CALIBRATIONS_EXPORT_SUCCESS",
      defaultMessage: "Calibration results exported successfully.",
      description: "Calibration results export success message",
    }),
  });

  const mutationFn = () => {
    return Cafs.exportAllCalibrations(
      { path: { datasetId: selectedDataset?.Id! } },
      { IncludeReferences: false },
    );
  };

  const { mutate: exportAllCalibrations, error } = useMutation<
    FileResponse | null,
    ApiError,
    void
  >({
    mutationKey: [MutationKey.ExportCalibrations],
    mutationFn: mutationFn,
    onSuccess: response => {
      if (response) {
        handleSuccess();
        saveFile(response);
      } else {
        showSnackbar({
          type: SnackbarType.Warning,
          message: formatMessage({
            id: "ACTION.NO_CALIBRATIONS_AVAILABLE",
            defaultMessage: "No calibration results available",
            description: "No calibration results warning message",
          }),
        });
      }
    },
  });

  useFetchError(error);

  return { exportAllCalibrations };
};
